// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.confirmation-sent{
  text-align:center;
}

  .confirmation-sent__title{
    margin:0 0 1rem;
  }

  .confirmation-sent__link{
    display:block;
    -webkit-text-decoration:underline;
    text-decoration:underline;
    cursor:pointer;
  }

  .confirmation-sent__email{
    font-weight:700;
  }
`, ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
